import styled, { css, keyframes } from 'styled-components';

export const Container = styled.div`
  margin: 3%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  h1 {
    margin: 0;
    font-size: 34px;
  }
`;

export const Period = styled.div`
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 8px 12px;
  font-weight: 600;
`;

export const CardGrid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
`;

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 14px;
  min-height: 96px;
`;

export const CardLabel = styled.div`
  color: #5f5f5f;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CardValue = styled.div`
  margin-top: 10px;
  font-size: 28px;
  font-weight: 700;
  color: #323232;
`;

export const SectionGrid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Section = styled.section`
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 14px;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 14px;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Bar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;
`;

export const BarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;

  span {
    color: #323232;
    max-width: 80%;
  }

  b {
    color: #323232;
    white-space: nowrap;
  }
`;

export const BarFill = styled.div<{ danger?: boolean }>`
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: #eef0f3;
  overflow: hidden;

  div {
    height: 100%;
    background: ${({ danger }) =>
      danger
        ? 'linear-gradient(90deg, #d94747, #ef6b6b)'
        : 'linear-gradient(90deg, #3a78f2, #6a7df7)'};
    border-radius: 999px;
    min-width: 4px;
  }
`;

export const AlertList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const AlertCard = styled.div<{ type: 'warning' | 'danger' | 'info' }>`
  border: 1px solid
    ${({ type }) => {
      if (type === 'danger') return '#f0b6b6';
      if (type === 'warning') return '#f1d29a';
      return '#bcd0f8';
    }};
  background: ${({ type }) => {
    if (type === 'danger') return '#fff4f4';
    if (type === 'warning') return '#fff9ef';
    return '#f3f8ff';
  }};
  border-radius: 6px;
  padding: 10px;

  b {
    font-size: 14px;
  }

  p {
    margin: 6px 0 0;
    font-size: 14px;
  }
`;

export const Empty = styled.div`
  color: #6e6e6e;
  font-size: 14px;
`;

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const skeletonStyle = css`
  background: linear-gradient(90deg, #f2f2f2 0px, #e8e8e8 40px, #f2f2f2 80px);
  background-size: 600px;
  animation: ${shimmer} 1.4s infinite linear;
`;

export const SkeletonCardGrid = styled(CardGrid)``;

export const SkeletonCard = styled.div`
  border-radius: 8px;
  min-height: 96px;
  ${skeletonStyle}
`;

export const SkeletonBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
`;

export const SkeletonLine = styled.div<{ width: string; height?: string }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height || '14px'};
  border-radius: 6px;
  ${skeletonStyle}
`;

export const Tooltip = styled.div`
  position: relative;
  display: inline-flex;

  span {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s ease;
    position: absolute;
    top: 26px;
    left: 0;
    width: 280px;
    z-index: 20;
    padding: 8px 10px;
    border-radius: 6px;
    background: #2f2f2f;
    color: #fff;
    font-size: 12px;
    line-height: 1.4;
    font-weight: 400;
  }

  &:hover span {
    visibility: visible;
    opacity: 1;
  }
`;

export const TooltipIcon = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #8d8d8d;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8d8d8d;

  svg {
    width: 12px;
    height: 12px;
  }
`;
